<template lang="html">
  <div class="bg-herocream min-h-screen pt-32">
    <MainHeader />
    <Dash />
  </div>
</template>

<script>
  import MainHeader from "@/components/header/MainHeader.vue"
  import Dash from "@/components/admin/Dash.vue"
  export default {
    name: 'Admin',
    components: {
      Dash,
      MainHeader
    }
  }
</script>

<style lang="css">
</style>
